/* eslint-disable */
import { NewsApi } from 'api'
import { Dispatch } from 'redux'
import { NewsAction, NewsActionTypes } from 'store/types/news'

export type newsSearch = {
  sortField?: string
  sortDirection?: number
  searchString?: string
  size?: number
  offset?: number
  // при изменении названия параметра поменять и в админке корп сайта
  draftListId?: string
}

const newsApi = new NewsApi()

export const fetchNews = (isMore = false, search: newsSearch = {}) => {
  //TODO: Вызов апи
  return async (dispatch: Dispatch<NewsAction>): Promise<void> => {
    try {
      dispatch({ type: NewsActionTypes.FETCH_NEWS })

      const result = await getNews(search)

      // delay(() => {
      dispatch({
        type: isMore
          ? NewsActionTypes.FETCH_NEWS_SUCCESS_MORE
          : NewsActionTypes.FETCH_NEWS_SUCCESS,
        payload: {
          items: result?.data?.data || [],
          total: result?.data?.total || 0,
        },
      })
      // }, 5000)
    } catch (e) {
      dispatch({
        type: NewsActionTypes.FETCH_NEWS_ERROR,
        payload: 'Произошла ошибка при загрузке',
      })
    }
  }
}

export const fetchNewsItem = (id: string, isDraft?: boolean) => {
  //TODO: Вызов апи
  return async (dispatch: Dispatch<NewsAction>): Promise<void> => {
    try {
      dispatch({ type: NewsActionTypes.FETCH_ITEM_NEWS })
      const result = await getNewsItem(id, isDraft)
      // delay(() => {
      dispatch({
        type: NewsActionTypes.FETCH_ITEM_NEWS_SUCCESS,
        payload: result?.data || null,
      })
      // }, 1000)
    } catch (e) {
      dispatch({
        type: NewsActionTypes.FETCH_NEWS_ERROR,
        payload: 'Произошла ошибка при загрузке',
      })
    }
  }
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function getNews(filters: newsSearch = {}) {
  const { searchString, sortField, sortDirection, size, offset, draftListId } =
    filters

  if (draftListId) {
    return newsApi.getNewsListWithDraft(
      draftListId,
      searchString,
      sortField,
      sortDirection,
      size,
      offset
    )
  }

  return newsApi.getNewsListPublished(
    searchString,
    sortField,
    sortDirection,
    size,
    offset
  )
}

export function getNewsItem(id: string, isDraft?: boolean) {
  if (isDraft) {
    return newsApi.getNewsEntity(id)
  }

  return newsApi.getNewsPublishedEntity(id)
}
